import React, { useEffect, useState } from 'react'
import { Card, Row, Col } from 'antd'
import {
  DatabaseOutlined,
  BgColorsOutlined,
  ShoppingCartOutlined,
  CheckCircleOutlined,
  TruckOutlined,
  RiseOutlined,
  WarningOutlined,
  AppstoreOutlined,
  FundOutlined,
} from '@ant-design/icons'

import './Dashboard.css'
import { GetDashboardDataAPI } from '../../AllAPI/AdminAPI'
import axiosInstance from '../../Utils/axiosInstance'

const Dashboard = () => {
  const selectedYear = Number(sessionStorage.getItem('year'))
  const [dashboardData, setDashboardData] = useState({})

  useEffect(() => {
    fetchDashboardData()
  }, [])

  const fetchDashboardData = async () => {
    try {
      const res = await axiosInstance.get(`${GetDashboardDataAPI}/${selectedYear}`)
      setDashboardData(res.data)
    } catch (error) {
      console.error('Dashboard API error', error)
    }
  }

  //  Card Configuration
  const dashboardCards = [
    {
      label: 'Product Count',
      value: dashboardData.totalProductCount,
      icon: <AppstoreOutlined />,
      color: 'red',
    },
    {
      label: 'Production Count',
      value: dashboardData.productionCount,
      icon: <DatabaseOutlined />,
      color: 'blue',
    },
    {
      label: 'Coloring Count',
      value: dashboardData.coloringCount,
      icon: <BgColorsOutlined />,
      color: 'green',
    },
    {
      label: 'Breakage Count',
      value: dashboardData.totalBreakageEntryQuantity,
      icon: <WarningOutlined />,
      color: 'cyan',
    },
    {
      label: 'Order Count',
      value: dashboardData.totalOrderCount,
      icon: <ShoppingCartOutlined />,
      color: 'orange',
    },
    {
      label: 'Order Approval Count',
      value: dashboardData.totalOrderApprovalCount,
      icon: <CheckCircleOutlined />, 
      color: 'purple',
    },
    {
      label: 'Delivery Count',
      value: dashboardData.totalDeliveryCount,
      icon: <TruckOutlined />, 
      color: 'teal',
    },
    {
      label: 'Sale Count',
      value: dashboardData.totalSaleEntryCount,
      icon: <RiseOutlined />, 
      color: 'pink',
    },
    {
      label: 'Available Stock',
      value: dashboardData.availableStock,
      icon: <FundOutlined />, 
      color: 'indigo',
    },
    {
      label: 'Delivered Product Count',
      value: dashboardData.productDelivaryCount,
      icon: <TruckOutlined />, 
      color: 'teal',
    },
  ]

  return (
    <>
      <h2 className="dashboard-title">Dashboard Overview</h2>

      <Row gutter={[16, 16]}>
        {dashboardCards.map((card, index) => (
          <Col xs={24} sm={12} md={12} lg={6} key={index}>
            <Card className={`dashboard-card ${card.color}`}>
              <div className="card-content">
                <span className="card-icon">{card.icon}</span>
                <div>
                  <p className="card-label">{card.label}</p>
                  <h3 className="card-value">{card.value ?? 0}</h3>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  )
}

export default Dashboard
